import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://demo.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'demo-key'

// Verificar se estamos em modo de desenvolvimento sem configuração
const isDemoMode = !import.meta.env.VITE_SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL === 'your_supabase_url_here'

if (isDemoMode) {
  console.warn('🚧 MODO DEMO: Supabase não configurado. Algumas funcionalidades não funcionarão.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
})

// Flag para verificar se estamos em modo demo
export const isSupabaseConfigured = !isDemoMode

// Tipos do banco de dados
export interface Profile {
  id: string
  name: string
  full_name?: string
  email: string
  phone?: string
  bio?: string
  description?: string
  avatar_url?: string
  profile_image_url?: string
  cover_photo?: string
  photos: string[]
  services?: string[]
  payment_methods?: string[]
  serves_who?: string[]
  availability?: any
  is_online: boolean
  last_seen?: string
  city?: string
  state?: string
  neighborhood?: string
  cep?: string
  hourly_rate?: number
  approved_at?: string
  approved_by?: string | null
  is_model?: boolean
  approval_status?: 'pending' | 'approved' | 'rejected'
  created_at: string
  updated_at: string
}

export interface Client {
  id: string
  name: string
  email: string
  avatar_url?: string
  created_at: string
  updated_at: string
}

export interface UserWallet {
  id: string
  user_id: string
  token_balance: number
  created_at: string
  updated_at: string
}

export interface PublicChatMessage {
  id: string
  profile_id: string
  sender_id: string
  sender_type: 'model' | 'client'
  content?: string
  image_url?: string
  image_cost: number
  created_at: string
}

export interface ImageUnlock {
  id: string
  user_id: string
  message_id: string
  cost: number
  created_at: string
}

export interface ModelEarning {
  id: string
  model_id: string
  client_id: string
  amount: number
  transaction_type: string
  message_id?: string
  created_at: string
}
